import CustomAttributePermissionsAPI from '../../api/customAttributePermissions';

// Which custom attribute keys the CURRENT user must not see, per attribute model.
//
// `enabled` mirrors the account feature flag. While it is false — the state of
// every account until it is switched on — `hiddenKeys` stays empty and every
// consumer behaves exactly as it did before this feature existed.
export const state = {
  enabled: false,
  hidden: {
    conversation_attribute: [],
    contact_attribute: [],
  },
  uiFlags: {
    isFetching: false,
    hasFetched: false,
  },
};

export const getters = {
  isEnabled: _state => _state.enabled,
  getUIFlags: _state => _state.uiFlags,
  // Returns a plain array so callers can `includes(...)` without a null check.
  getHiddenKeys: _state => attributeModel =>
    _state.hidden[attributeModel] || [],
  isHidden: _state => (attributeModel, attributeKey) =>
    (_state.hidden[attributeModel] || []).includes(attributeKey),
};

export const actions = {
  // Never throws: the sidebar must render even if this call fails. A failure
  // leaves `hidden` empty, which shows everything — the same as today, and the
  // safe direction for a decluttering feature.
  get: async ({ commit }) => {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await CustomAttributePermissionsAPI.getResolved();
      commit('SET_PERMISSIONS', data);
    } catch (error) {
      // Logged, not rethrown: the fail-open below is deliberate, but swallowing
      // the error silently meant a /resolved that started failing looked exactly
      // like an account with nothing configured.
      // eslint-disable-next-line no-console
      console.error('[customAttributePermissions] failed to resolve', error);
      commit('SET_PERMISSIONS', { enabled: false, hidden: {} });
    } finally {
      commit('SET_UI_FLAG', { isFetching: false, hasFetched: true });
    }
  },
};

export const mutations = {
  SET_UI_FLAG(_state, flags) {
    _state.uiFlags = { ..._state.uiFlags, ...flags };
  },
  SET_PERMISSIONS(_state, payload) {
    _state.enabled = payload?.enabled === true;
    _state.hidden = {
      conversation_attribute: payload?.hidden?.conversation_attribute || [],
      contact_attribute: payload?.hidden?.contact_attribute || [],
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
